<div style="position:relative; top: 8px; right: 8px;">
  <div style="position: relative; float: right; height: 0" class="link-button">
    <a class="muted7" (click)="click('showCancel')">
      <img src="./assets/images/close.svg" alt="close" class="filter-invert" />
    </a>
  </div>
</div>
<table class="w-hundred">
  <th id="order-form-click-left-nav" class="th-display-none"></th>
  <tbody>
    <tr>
      <td width="262" class="model-left-nav edit-model-menu">
        <modal-left-nav [(nav)]="leftNav" (onClick)="clickLeftNav($event)"></modal-left-nav>
      </td>
      <td class="model-body-td">
        <div id="formTop" class="edit-model-body">
          <div class="medium large-text edit-header">
            <div style="display:inline-block">
              <span (click)="logForm()">{{title}}</span> {{isAdding ? '(New)' : '(Edit)'}}
              <span *ngIf="model?.invoiceId && !formSettings.disableInvoicing && ((sharedServiceClient.getPermissions('invoices') && (model?.readyToAuditForOrder==false || model?.readyToAuditForOrder==null || model?.status == 6) ) || (sharedServiceClient.getPermissions('ready_to_audit') && model?.readyToAuditForOrder==true))" style="float: right"><a
                  style="padding-left: 8px;" class="link-button" (click)="showInvoice()">View Invoice</a></span>
              <div class="small-text italic">{{(!isAdding) ? model?.statusName : ''}}</div>
            </div>
            <div style="text-align: right">
              <order-tags [order]="model" class="invoice-order"></order-tags>
              <ng-container *ngFor="let b of getButtons">
                <ng-container *ngIf="b.key == 'draft' && isAdding && !isLoading">
                  <button *ngIf="b.key == 'draft' && isAdding" pButton [label]="b.label"
                    [class]="'custom-button-compact ' + (b.class ? b.class : '')" type="button" (click)="click(b.key)"
                    [disabled]="!canAddDraft" style="margin-left: 7px"></button>
                </ng-container>
                <ng-container *ngIf="!isAdding || b.key != 'draft'">
                  <button *ngIf="b.validate === true" pButton [label]="b.label"
                    [class]="'custom-button-compact ' + (b.class ? b.class : '')" type="button" (click)="click(b.key)"
                    [disabled]="formInvalid || isLoading || isPopupOpen || isPolicyExpired || isPolicyEmpty || !isTransitCompleteCarrier" style="margin-left: 7px"></button>
                  <button *ngIf="b.validate === false && b.label !== 'Save'" pButton [label]="b.label"
                    [class]="'custom-button-compact ' + (b.class ? b.class : '')" type="button" (click)="click(b.key)"
                    style="margin-left: 7px" [disabled]="isLoading || isPopupOpen"></button>
                  <button *ngIf="b.validate === false && b.label === 'Save'" pButton [label]="b.label"
                    [class]="'custom-button-compact ' + (b.class ? b.class : '')" type="button" (click)="click(b.key)"
                    style="margin-left: 7px" [disabled]="isLoading || isValidETAReason"></button>
                </ng-container>
              </ng-container>
            </div>
            <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;" [hidden]="isOrderConfirmDelivery && leftNavSelected == 'confirmation'"></div>
          </div>
          <!-- <loading *ngIf="isLoading" class="p-1"></loading> -->
          <ng-container *ngIf="!isLoading">
            <div class="edit-menu-items">
            <ng-container [ngSwitch]="leftNavSelected">
              <div *ngSwitchCase="'basic'" class="large-text">
                Basic
              </div>
              <div *ngSwitchCase="'order'" class="large-text">
                Order
              </div>
              <div *ngSwitchCase="'vehicles'" class="large-text">
                Vehicles
              </div>
              <div *ngSwitchCase="'customer'" class="large-text">
                Customer
              </div>
              <div *ngSwitchCase="'pickup'" class="large-text">
                Pickup
                <div class="toolbar-link">
                  <a *ngIf="showLocationSearchButton" class="link-button"
                    (click)="loadExistingLocation('pickup')">Load Existing Location</a>
                </div>
                <div *ngIf="showLocationSearchButton" class="toolbar-link-spacer"></div>
                <div class="toolbar-link">
                  <a class="link-button" (click)="populatePickup(getCustomerFromForm())">Use Customer Location</a>
                </div>
              </div>
              <div *ngSwitchCase="'delivery'" class="large-text">
                Delivery
                <div class="toolbar-link">
                  <a *ngIf="showLocationSearchButton" class="link-button"
                    (click)="loadExistingLocation('delivery')">Load Existing Location</a>
                </div>
                <div *ngIf="showLocationSearchButton" class="toolbar-link-spacer"></div>
                <div class="toolbar-link">
                  <a class="link-button" (click)="populateDelivery(getCustomerFromForm())">Use Customer Location</a>
                </div>
              </div>
              <div *ngSwitchCase="'billing'" class="large-text">
                Billing
              </div>
              <div *ngSwitchCase="'dispatch'" class="d-flex align-items-baseline">
                <h4 class="large-text">
                Dispatch
                </h4>
                <div class="d-flex align-items-baseline ml-auto">
                  <div *ngIf="isNewBookedOrderNumber" class="d-flex align-items-baseline">
                    <div class="carrier-text-alignment">{{metadata['whoBooked']}}</div>
                    <div class="ml-2">
                      <simple-control [form]="form" key="whoBooked" [label]="metadata['whoBooked']" type="lookup" [filter]="true"
                        [items]="lookups.agentsonly"></simple-control>
                    </div>
                  </div>
                  <div *ngIf="isNewBookedOrderNumber" class="d-flex align-items-baseline ml-3">
                    <div class="carrier-text-alignment">{{metadata['bookedBy']}}</div>
                    <div class="ml-2">
                      <simple-control [form]="form" key="bookedBy" [label]="metadata['bookedBy']" type="lookup"
                        [items]="lookups.bookedBy"></simple-control>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'pickupDetails'" class="large-text">
                Pickup Details
              </div>
              <div *ngSwitchCase="'deliveryDetails'" class="large-text">
                Delivery Details
              </div>
              <div *ngSwitchCase="'documents'" class="large-text">
                Documents
              </div>
              <div class="d-flex">
                <div *ngSwitchCase="'notes'" class="large-text w-50 f-w-bold">
                  Order Notes
                </div>
                <div class="ordernotes-border mx-1"></div>
                <div *ngSwitchCase="'notes'" class="large-text w-50 f-w-bold">
                  New ETA Notes
                </div>
              </div>
            </ng-container>

            <form *ngIf="!isLoading" [formGroup]="form" (ngSubmit)="save()">
              <simple-control [form]="form" key="id" type="hidden"></simple-control>
              <table class="form-table" [ngClass]="{'customer-order-form':  leftNavSelected == 'basic'}" [class.d-none]="leftNavSelected == 'notes'">
                <thead>
                  <tr>
                    <th id="order-form-rush" style="width: 35%"></th>
                    <th id="order-form-vip"></th>
                  </tr>
                </thead>

                <ng-container *ngIf="status >= -1">
                  <tbody [hidden]="leftNavSelected != 'basic'">
                    <tr *ngIf="isNewHubSpotDealOrderNumber">
                      <td>{{ metadata['hubspotDealId']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [form]="form" key="hubspotDealId" [label]="metadata['hubspotDealId']"
                          type="number" [readonly]="status > 1 || model?.isHubspotDealClosed"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="status < 1 && isShowPickupPassword && !isTenderOrder">
                      <td>{{ metadata['generatePickupPassword']}}</td>
                      <td>
                        <simple-control [label]="metadata['generatePickupPassword']" [form]="form" key="generatePickupPassword" type="boolean">
                        </simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="model?.generatePickupPassword && status >= 1 && isShowPickupPassword && !isTenderOrder">
                      <td>{{ metadata['pickupPassword']}}</td>
                      <td class="order-from-pd pickup-password">
                        <simple-control [class]="'width-sixtyfive'" [form]="form" key="pickupPassword" [label]="metadata['pickupPassword']"
                          type="text" [readonly]="true"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td [style.background]="form.get('rush')?.value ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['rush']}}</td>
                      <td [style.background]="form.get('rush')?.value ? 'rgba(250, 250, 0, 0.7)' : null">
                        <simple-control [label]="metadata['rush']" [form]="form" key="rush" type="boolean">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td [style.background]="form.get('vip').value ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['vip']}}</td>
                      <td [style.background]="form.get('vip').value ? 'rgba(250, 250, 0, 0.7)' : null">
                        <simple-control [label]="metadata['vip']" [form]="form" key="vip" type="boolean">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['payDrop']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['payDrop']" [form]="form" key="payDrop" type="lookup"
                          [items]="lookups.yesNoNull" [required]="true"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['perVehicleDollarAmount']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [form]="form" key="perVehicleDollarAmount"
                          [label]="metadata['perVehicleDollarAmount']" type="currency" [required]="payDropRequired"
                          [readonly]="!payDropRequired" [readonlyLabel]="'N/A'"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['payDropReason']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [form]="form" key="payDropReason" [label]="metadata['payDropReason']"
                          type="text" [required]="payDropRequired" [readonly]="!payDropRequired"
                          [readonlyLabel]="'N/A'"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['multipleOrders']}}</td>
                      <td>
                        <simple-control [ngClass]="{'disabled-mark-complete-checkbox': isMultipleOderReadOnly}" [class]="'width-sixtyfive'" [label]="'Multiple Orders'" [form]="form" key="dealerTrade" type="lookup"
                                        [items]="lookups.multipleorders" [required]="true"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isAdding && form.get('dealerTrade')?.value == 5">
                      <td>{{metadata['numOrders']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['numOrders']" [form]="form" key="numOrders" type="positiveNumber"
                                        [required]="true"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isAdding && form.get('dealerTrade')?.value == 5">
                      <td>{{metadata['sameCustomer']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['sameCustomer']" [form]="form" key="sameCustomer"
                                        type="boolean"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isAdding && form.get('dealerTrade')?.value == 5">
                      <td>{{metadata['samePickup']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['samePickup']" [form]="form" key="samePickup" type="boolean">
                        </simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isAdding && form.get('dealerTrade')?.value == 5">
                      <td>{{metadata['sameDelivery']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['sameDelivery']" [form]="form" key="sameDelivery"
                                        type="boolean"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isAdding && form.get('dealerTrade')?.value == 5">
                      <td>{{metadata['samePaymentNotes']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['samePaymentNotes']" [form]="form" key="samePaymentNotes"
                                        type="boolean"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['privateCustomer']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['privateCustomer']" [form]="form" key="privateCustomer"
                                        type="lookup" (onChange)="onPrivateCutomerChange()" [items]="lookups.yesNoNull" [readonly]="formSettings.disablePrivateCustomer">
                        </simple-control>
                      </td>
                    </tr>
                    <tr [style.background]=" showPickupDoc || showCustomerDoc || showDeliveryDoc || showYesCustomerDocs || form.get('customerDocs').value === 2 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <td>{{metadata['customerDocs']}}</td>
                      <td class="customerDocs" *ngIf="!isNewCustomerDocOrder">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerDocs']" [form]="form" key="customerDocs"
                          type="lookup" [items]="lookups.yesNoNull" (onChange)="onCustomerDocs($event)"></simple-control>
                      </td>
                      <td class="customerDocs customer-doc-bg" *ngIf="isNewCustomerDocOrder">
                          <p-multiSelect styleClass="simple-control width-sixtyfive" appendTo="body" [showToggleAll]="false" (onChange)="onCustomerDocDropDownSelect('customerDocs',$event.value)"
                          [options]="lookups.customerDocs" [formControl]="form.get('customerDocs')" [maxSelectedLabels]="500">
                         </p-multiSelect>
                         <dynamic-control-error [formControl]="form.get('customerDocs')" [controlName]="metadata['customerDocs']"
                      ngDefaultControl></dynamic-control-error>
                      </td>
                    </tr>
                    <tr *ngIf="showCustomerDoc && isNewCustomerDocOrder">
                      <td>{{metadata['customerDocCustomer']}}</td>
                      <td>
                        <p-multiSelect styleClass="simple-control width-sixtyfive" appendTo="body" [showToggleAll]="false" [maxSelectedLabels]="500"
                        [options]="lookups.customerDocOptions" [formControl]="form.get('customerDocCustomer')">
                      </p-multiSelect>
                      <dynamic-control-error [formControl]="form.get('customerDocCustomer')" [controlName]="metadata['customerDocCustomer']"
                      ngDefaultControl></dynamic-control-error>
                      </td>
                    </tr>
                    <tr *ngIf="showPickupDoc && isNewCustomerDocOrder">
                      <td>{{metadata['customerDocPickup']}}</td>
                      <td>
                        <p-multiSelect styleClass="simple-control width-sixtyfive" appendTo="body" [showToggleAll]="false" [maxSelectedLabels]="500"
                        [options]="lookups.customerDocOptions" [formControl]="form.get('customerDocPickup')">
                      </p-multiSelect>
                      <dynamic-control-error [formControl]="form.get('customerDocPickup')" [controlName]="metadata['customerDocPickup']"
                      ngDefaultControl></dynamic-control-error>
                      </td>
                    </tr>
                    <tr *ngIf="showDeliveryDoc && isNewCustomerDocOrder">
                      <td>{{metadata['customerDocDelivery']}}</td>
                      <td>
                        <p-multiSelect styleClass="simple-control width-sixtyfive" appendTo="body" [showToggleAll]="false" [maxSelectedLabels]="500"
                        [options]="lookups.customerDocOptions" [formControl]="form.get('customerDocDelivery')">
                        </p-multiSelect>
                      <dynamic-control-error [formControl]="form.get('customerDocDelivery')" [controlName]="metadata['customerDocDelivery']"
                      ngDefaultControl></dynamic-control-error>
                      </td>
                    </tr>
                    <tr *ngIf="showCustomerDocsDate">
                      <td>{{metadata['customerDocsSignedDate']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerDocsSignedDate']" [form]="form"
                                        key="customerDocsSignedDate" type="date"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isAdding">
                      <td>{{metadata['newClient']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['newClient']" [form]="form" key="newClient" type="lookup"
                                        [items]="lookups.yesNoNull" [readonly]="isPrivateCustomer" [readonlyLabel]="'No'">
                        </simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="foundAssignedTo != null && !foundAssignedTo">
                      <td>Current Assignee</td>
                      <td class="current-assignes">{{model.assignedToName}}</td>
                    </tr>
                    <tr>
                      <td>{{metadata['assignedTo']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [markForCheck]="changeEvents['agents'].asObservable()"
                                        [label]="metadata['assignedTo']" [form]="form" key="assignedTo" type="lookup"
                                        (onChange)="setAgentCommissionPercentage($event.value,lookups.agents)" [items]="lookups.agents"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isAdmin">
                      <td>{{metadata['salesAgentCommissionPercentage']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['salesAgentCommissionPercentage']" [form]="form"
                                        key="salesAgentCommissionPercentage" [required]="true" type="number" [searchNumberOfVehicles]="true"></simple-control>
                      </td>
                    </tr>
                  </tbody>

                  <tbody [hidden]="leftNavSelected != 'order'">
                    <tr [style.background]="form.get('depositRequired').value === 2 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <td>{{metadata['depositRequired']}}</td>
                      <td class="customerDocs customer-doc-bg">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['depositRequired']" [form]="form" key="depositRequired"
                          type="lookup" [items]="lookups.yesNoNull"
                          [readonly]="!form.get('privateCustomer').value || form.get('privateCustomer').value == 1"
                          [readonlyLabel]="'N/A'" (onChange)="calculateCompanyProfit()"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['reviewRequired']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['reviewRequired']" [form]="form" key="reviewRequired"
                          type="lookup" [items]="lookups.reviewRequested"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['isPrivateCustomerAtPickupOrDelivery']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['isPrivateCustomerAtPickupOrDelivery']" [form]="form"
                          key="isPrivateCustomerAtPickupOrDelivery" type="lookup" [items]="lookups.yesNoNull">
                        </simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isPrivateCustomerAtPickupOrDeliveryCheck">
                      <td>{{metadata['privateCustomerLocationType']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [form]="form" key="privateCustomerLocationType"
                          [label]="metadata['privateCustomerLocationType']" type="lookup"
                          [items]="lookups.privateCustomerLocationType"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['specialInstructions']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive pickup-password'" [label]="metadata['specialInstructions']" [form]="form"
                          key="specialInstructions" type="textarea"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['isDocumentationNecessary']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['isDocumentationNecessary']" [form]="form"
                          key="isDocumentationNecessary" type="lookup" [items]="lookups.yesNoNull"></simple-control>
                      </td>
                    </tr>
                  </tbody>

                  <tbody [hidden]="leftNavSelected != 'vehicles'">
                    <tr>
                      <td>{{metadata['openEnclosed']}}</td>
                      <td>
                        <simple-control [label]="metadata['openEnclosed']" [form]="form" key="openEnclosed" type="radio"
                          [items]="lookups.openEnclosed"></simple-control>
                      </td>
                    </tr>
                  </tbody>

                  <tbody [hidden]="leftNavSelected != 'customer'">
                    <tr *ngIf="showContacts && !isPrivateCustomer">
                      <td>Customer</td>
                      <td>
                        <p-autoComplete dataKey="value" [formControl]="form.get('selectedCustomer')" field="label" class="selectcustomer-width"
                          inputStyleClass="simple-control" [suggestions]="customerItems"
                          appendTo="body" [readonly]="formSettings?.disableCustomer"
                          (completeMethod)="customerSearch($event)" (onSelect)="customerSelect($event.value)"
                          forceSelection="true"></p-autoComplete>
                          <dynamic-control-error [formControl]="form.get('selectedCustomer')" [controlName]="'Customer'"
                          ngDefaultControl></dynamic-control-error>
                      </td>
                    </tr>
                    <tr *ngIf="(showContacts || customerId != null) && !isPrivateCustomer">
                      <td>
                        Additional Contact Emails
                      </td>
                      <td class="order-from-pd">
                        <div *ngFor="let p of addlInfoArray('emails') let i=index" class="additional-email-alignment">
                          <input appSanitizeInput style="width: 80%" pInputText type="text" [(ngModel)]="additionalInfo['emails'][i]" (input)="validate_additional_emails('customer','emails')"
                          [ngModelOptions]="{standalone: true}" #customer_additional_email="ngModel" autocomplete="off" class="simple-control"
                            [pattern]="email_pattern"
                            />
                          <span><a (click)="confirmDelete('Email', i)" class="link-button"
                              style="font-size: 16px; color: maroon !important">&nbsp;X</a></span>
                              <div *ngIf="customer_additional_email.errors?.pattern">
                                <span  style="font-size: 0.85em; color: #b00!important">
                                  * Email is not a valid email address
                                </span>
                              </div>
                        </div>
                        <div class="add-info-spacing">
                          <a (click)="addAddlInfo('emails')" class="link-button">+ Add Email</a>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="requiresCustomerFirstLast && isOldRecords">
                      <td>{{metadata['customerFirstName']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerFirstName']" [form]="form" key="customerFirstName" [readonly]="true"
                          type="text"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="requiresCustomerFirstLast && isOldRecords">
                      <td>{{metadata['customerLastName']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerLastName']" [form]="form" key="customerLastName" [readonly]="true"
                          type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['customerBusinessName']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerBusinessName']" [form]="form"
                          key="customerBusinessName" type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['customerBusinessHours']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerBusinessHours']" [form]="form"
                          key="customerBusinessHours" type="textarea"
                          [required]="form.get('customerBusinessName')?.value?.length > 0"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="requiresCustomerEmail">
                      <td>{{metadata['customerEmail']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerEmail']" [form]="form" key="customerEmail"
                          type="email" [required]="requiresCustomerEmail"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['customerAddress1']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerAddress1']" [form]="form" key="customerAddress1"
                          type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['customerCity']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerCity']" [form]="form" key="customerCity" type="text">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['customerStateCode']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerStateCode']" [form]="form" key="customerStateCode"
                          type="lookup" [items]="lookups.stateCodes"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['customerZip']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerZip']" [form]="form" key="customerZip" type="zip">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['customerPhoneType']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerPhoneType']" [form]="form" key="customerPhoneType"
                          type="lookup" [items]="lookups.phoneTypes"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['customerPhone']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerPhone']" [form]="form" key="customerPhone"
                          type="phone"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="!requiresCustomerEmail">
                      <td>{{metadata['customerEmail']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerEmail']" [form]="form" key="customerEmail"
                          type="email"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="!requiresCustomerEmail && isPrivateCustomer">
                      <td>
                        Additional Contact Emails
                      </td>
                      <td class="date-overhaul-spacing">
                        <div *ngFor="let p of addlInfoArray('emails') let i=index" class="additional-email-alignment">
                          <input appSanitizeInput style="width: 80%" pInputText type="text" [(ngModel)]="additionalInfo['emails'][i]" (input)="validate_additional_emails('customer','emails')"
                            [ngModelOptions]="{standalone: true}"  #additionalEmail="ngModel"  autocomplete="off" class="simple-control"
                            [pattern]="email_pattern"/>
                          <span><a (click)="confirmDelete('Email', i)" class="link-button"
                              style="font-size: 16px; color: maroon !important">&nbsp;X</a></span>
                              <div *ngIf="additionalEmail.errors?.pattern">
                                <span  style="font-size: 0.85em; color: #b00!important">
                                  * Email is not a valid email address
                                </span>
                              </div>
                            </div>
                        <div>
                          <a (click)="addAddlInfo('emails')" class="link-button">+ Add Email</a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['segment']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['segment']" [form]="form" key="segment" (onChange)="onSegmentChange()"
                          type="lookup" [items]="lookups.segment"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="form.get('segment').value === 6 || form.get('segment').value === 7">
                      <td>{{metadata['subsegment']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['subsegment']" [form]="form" key="subsegment"
                          type="lookup" [items]="form.get('segment').value === 6 ? lookups.subsegmentupfitter: lookups.sources"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="(showContacts || customerId != null) && !isPrivateCustomer">
                      <td>Contacts</td>
                      <td>
                        <p-multiSelect styleClass="simple-control width-sixtyfive" class="agent-proxyfor" appendTo="body" [maxSelectedLabels]="500"
                          [options]="customerContacts" [filter]="true" [disabled]="isContactDisabled"
                          (onChange)="selectContacts($event, customerContacts, 'contacts')" [showToggleAll]="false" 
                          [formControl]="form.get('selectedLoadExistingCustomer')"></p-multiSelect>
                        <dynamic-control-error [formControl]="form.get('customerContacts')" [controlName]="Contact"
                          ngDefaultControl></dynamic-control-error>
                      </td>
                    </tr>
                    <tr *ngIf="isAdding && newClientSelected && isNewClient">
                      <td>{{metadata['saveCustomer']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['saveCustomer']" [form]="form" key="saveCustomer"
                          type="boolean"></simple-control>
                      </td>
                    </tr>
                    <tr
                      *ngIf="isAdding && newClientSelected && isNewClient && form?.get('saveCustomer')?.value == true">
                      <td>{{metadata['enableNotifications']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['enableNotifications']" [form]="form"
                          key="enableNotifications" type="boolean"></simple-control>
                      </td>
                    </tr>
                  </tbody>

                  <tbody [hidden]="leftNavSelected != 'pickup'">
                    <tr>
                      <td>{{metadata['customerExpectedPickup']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerExpectedPickup']" [form]="form"
                          key="customerExpectedPickup" type="text"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isOldRecords">
                      <td>{{metadata['pickupFirstName']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupFirstName']" [form]="form" key="pickupFirstName" [readonly]="true" type="text"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isOldRecords">
                      <td>{{metadata['pickupLastName']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupLastName']" [form]="form" key="pickupLastName" [readonly]="true" type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['pickupBusinessName']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupBusinessName']" [form]="form" key="pickupBusinessName"
                          type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['pickupBusinessHours']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupBusinessHours']" [form]="form"
                          key="pickupBusinessHours" type="textarea"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['pickupAddress1']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupAddress1']" [form]="form" key="pickupAddress1"
                          type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['pickupCity']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupCity']" [form]="form" key="pickupCity" type="text">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['pickupStateCode']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupStateCode']" [form]="form" key="pickupStateCode"
                          type="lookup" [items]="lookups.stateCodes"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['pickupZip']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupZip']" [form]="form" key="pickupZip" type="zip">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['pickupPhone']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupPhone']" [form]="form" key="pickupPhone" type="phone">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Additional Pickup Phones
                      </td>
                      <td>
                        <div [formGroup]="form">
                          <div formArrayName="pickupPhones">
                            <table class="width-hundred">
                              <tr *ngFor="let c of form.get('pickupPhones').controls; let i=index">
                                <td class="padding-top-zero">
                                  <div class="pickup-phones">
                                    <input appSanitizeInput [formControlName]="i" [id]="key" pInputText [pKeyFilter]="phoneNumberRegex"
                                    type="text"
                                      [required]="required === true ? 'required' : null" [(ngModel)]="c.value" autocomplete="off"
                                      class="simple-control width-sixtyfive" />
                                    <span><a (click)="confirmDelete('Pickup Phone', i)" class="link-button"
                                        style="font-size: 16px; color: maroon !important">&nbsp;X</a></span>
                                  </div>
                                  <dynamic-control-error [formControl]="c" [controlName]="'PickupPhone'" ngDefaultControl></dynamic-control-error>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div class="pickup-phone-spacing">
                          <a (click)="addPickupPhone()" class="link-button">+ Add Pickup Phone</a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['pickupNotes']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['pickupNotes']" [form]="form" key="pickupNotes"
                          type="textarea"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="pickupLocationId != null && form?.get('useCustomerContactForPickup')?.value == false">
                      <td>Pickup Contacts</td>
                      <td>
                        <p-multiSelect styleClass="simple-control width-sixtyfive" class="agent-proxyfor" appendTo="body" [maxSelectedLabels]="500"
                          [options]="pickupLocationContacts" [formControl]="form.get('selectedLoadExistingLocationForPickup')" 
                          [disabled]="isPickupContactDisabled" [showToggleAll]="false" 
                          (onChange)="selectContacts($event, pickupLocationContacts, 'pickupContacts')">
                        </p-multiSelect>
                      </td>
                    </tr>
                    <tr *ngIf="(isNewClientYes || isNewClient) && isAdding && newClientSelected && !hideSaveAsNewLocationForPickUp">
                      <td>{{metadata['savePickup']}}</td>
                      <td>
                        <simple-control [label]="metadata['savePickup']" [form]="form" key="savePickup" type="boolean">
                        </simple-control>
                      </td>
                    </tr>
                  </tbody>

                  <tbody [hidden]="leftNavSelected != 'delivery'">
                    <tr>
                      <td>{{metadata['customerExpectedDelivery']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerExpectedDelivery']" [form]="form"
                          key="customerExpectedDelivery" type="text"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isOldRecords">
                      <td>{{metadata['deliveryFirstName']}}</td>
                      <td class="order-from-pd">
                        <simple-control [label]="metadata['deliveryFirstName']" [form]="form" key="deliveryFirstName" [readonly]="true" type="text"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="isOldRecords">
                      <td>{{metadata['deliveryLastName']}}</td>
                      <td class="order-from-pd">
                        <simple-control [label]="metadata['deliveryLastName']" [form]="form" key="deliveryLastName" [readonly]="true" type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deliveryBusinessName']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deliveryBusinessName']" [form]="form"
                          key="deliveryBusinessName" type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deliveryBusinessHours']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deliveryBusinessHours']" [form]="form"
                          key="deliveryBusinessHours" type="textarea"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deliveryAddress1']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deliveryAddress1']" [form]="form" key="deliveryAddress1"
                          type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deliveryCity']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deliveryCity']" [form]="form" key="deliveryCity" type="text">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deliveryStateCode']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deliveryStateCode']" [form]="form" key="deliveryStateCode"
                          type="lookup" [items]="lookups.stateCodes"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deliveryZip']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deliveryZip']" [form]="form" key="deliveryZip" type="zip">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deliveryPhone']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deliveryPhone']" [form]="form" key="deliveryPhone"
                          type="phone"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Additional Delivery Phones
                      </td>
                      <td>
                        <div [formGroup]="form">
                          <div formArrayName="deliveryPhones">
                            <table class="width-hundred">
                              <tr *ngFor="let c of form.get('deliveryPhones').controls; let i=index">
                                <td class="padding-top-zero">
                                  <div class="pickup-phones">
                                    <input appSanitizeInput [formControlName]="i" [id]="key" pInputText [pKeyFilter]="phoneNumberRegex"
                                    type="text"
                                      [required]="required === true ? 'required' : null" [(ngModel)]="c.value" autocomplete="off"
                                      class="simple-control width-sixtyfive" />
                                    <span><a (click)="confirmDelete('Delivery Phone', i)" class="link-button"
                                        style="font-size: 16px; color: maroon !important">&nbsp;X</a></span>
                                  </div>
                                  <dynamic-control-error [formControl]="c" [controlName]="'Delivery Phone'" ngDefaultControl></dynamic-control-error>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div class="pickup-phone-spacing">
                          <a (click)="addDeliveryPhone()" class="link-button">+ Add Delivery Phone</a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deliveryNotes']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deliveryNotes']" [form]="form" key="deliveryNotes"
                          type="textarea"></simple-control>
                      </td>
                    </tr>
                    <tr
                    *ngIf="deliveryLocationId != null && form?.get('useCustomerContactForDelivery')?.value == false">
                    <td>Delivery Contacts</td>
                    <td>
                      <p-multiSelect styleClass="simple-control width-sixtyfive" class="agent-proxyfor" appendTo="body" [maxSelectedLabels]="500"
                        [options]="deliveryLocationContacts" [filter]="true" [disabled]="isDeliveryContactDisabled" 
                        [formControl]="form.get('selectedLoadExistingLocationForDelivery')" [showToggleAll]="false" 
                        (onChange)="selectContacts($event, deliveryLocationContacts, 'deliveryContacts')">

                      </p-multiSelect>
                    </td>
                  </tr>
                    <tr *ngIf="(isNewClientYes || isNewClient) && isAdding && newClientSelected && !hideSaveAsNewLocation">
                      <td>{{metadata['saveDelivery']}}</td>
                      <td>
                        <simple-control [label]="metadata['saveDelivery']" [form]="form" key="saveDelivery"
                          type="boolean"></simple-control>
                      </td>
                    </tr>
                  </tbody>

                  <tbody [hidden]="leftNavSelected != 'billing'">

                    <tr>
                      <td>{{metadata['customerChargedType']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['customerChargedType']" [form]="form"
                          key="customerChargedType" type="lookup" [items]="lookups.customerChargedType"
                          (onChange)="customerChargedTypeChanged()">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['carrierPaymentType']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['carrierPaymentType']" [form]="form" key="carrierPaymentType"
                          type="lookup" [items]="lookups.carrierPaymentType" (onChange)="customerChargedTypeChanged()"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['price']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['price']" [form]="form" key="price" type="currency">
                        </simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['depositBy']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['depositBy']" [form]="form" key="depositBy" type="lookup"
                          [items]="lookups.paymentMethodDepositBy" [required]="model.status >= 3"
                          [readonly]="!form.get('depositRequired').value || form.get('depositRequired').value == 1 || form.get('depositRequired').value == 3"
                          [readonlyLabel]="'N/A'" (onChange)="calculateCompanyProfit()"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['deposit']}}</td>
                      <td class="order-from-pd">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['deposit']" [form]="form" key="deposit" type="currency"
                          [readonly]="!form.get('depositRequired').value || form.get('depositRequired').value == 1 || form.get('depositRequired').value == 3"
                          [readonlyLabel]="'N/A'" (onChange)="calculateCompanyProfit()"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>Balance Due</td>
                      <td class="order-from-pd">
                        <simple-control label="Balance Due" [form]="form" key="calculatedBalance" type="currency"
                          [readonly]="true" (onChange)="customerChargedTypeChanged()"></simple-control>
                      </td>
                    </tr>
                    <tr *ngIf="showDepositPaymentDate">
                      <td>{{metadata['depositPaymentDate']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['depositPaymentDate']" [form]="form" key="depositPaymentDate"
                          type="date" [required]="model.status == 3 && form.get('depositBy').value != 9" ></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['desiredProfit']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['desiredProfit']" [form]="form" key="desiredProfit"
                          type="text"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['poNumber']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['poNumber']" [form]="form" key="poNumber" type="text">
                        </simple-control>
                      </td>
                    </tr>
                    <tr [style.background]="form.get('additionalCost')?.value == 2 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <td>{{metadata['additionalCost']}}</td>
                      <td>
                        <simple-control [class]="'width-sixtyfive'" [hideError]="true" [label]="metadata['additionalCost']" [form]="form" key="additionalCost"
                          type="lookup" [items]="lookups.yesNoOnly" [required]="true"></simple-control>
                      </td>
                    </tr>
                    <tr>
                      <td>{{metadata['paymentNotes']}}</td>
                      <td class="broker-fee-spacing">
                        <simple-control [class]="'width-sixtyfive'" [label]="metadata['paymentNotes']" [form]="form" key="paymentNotes"
                          type="textarea"></simple-control>
                      </td>
                    </tr>
                  </tbody>
                </ng-container>

                <ng-container *ngIf="status >= 1">
                  <tbody [hidden]="leftNavSelected != 'confirmation'">
                    <tr>
                      <td colspan="4" class="pt-0" [ngClass]="isOrderConfirmDelivery ? 'order-confirmation' : null">
                        <table class="form-table">
                          <tr>
                            <td colspan="2" [ngClass]="isOrderConfirmDelivery ? 'border-right w-50' : null">
                              <table class="form-table">
                                <tr>
                                  <td [ngClass]="isOrderConfirmDelivery ? 'text-align-start w-25' : 'w-35'">
                                    {{metadata['confirmReadyForPickup']}}</td>
                                  <td class="text-align-start" [ngClass]="isOrderConfirmDelivery ? 'w-25' : null">
                                    <simple-control [form]="form" key="confirmReadyForPickup" [class]="isOrderConfirmDelivery ? null : 'width-sixtyfive'" [label]="metadata['confirmReadyForPickup']" type="lookup" [items]="lookups.yesNoNull"
                                    [required]="true"></simple-control>
                                  </td>
                                </tr>
                                <tr>
                                  <td [ngClass]="isOrderConfirmDelivery ? 'text-align-start' : null">{{metadata['confirmedBy']}}</td>
                                  <td class="text-align-start">
                                    <simple-control [form]="form" key="confirmedBy"  [class]="isOrderConfirmDelivery ? null : 'width-sixtyfive'" [label]="metadata['confirmedBy']" type="text">
                                    </simple-control>
                                  </td>
                                </tr>
                                <tr>
                                  <td [ngClass]="isOrderConfirmDelivery ? 'text-align-start' : null">{{metadata['customerExpectedPickup']}}</td>
                                  <td class="order-from-pd text-align-start">
                                    <simple-control  [class]="isOrderConfirmDelivery ? null : 'width-sixtyfive'" [label]="metadata['customerExpectedPickup']" [form]="form"
                                      key="customerExpectedPickup" [readonly]="true" type="text"></simple-control>
                                  </td>
                                </tr>
                                <!-- date-overhaul dynamic form for Customer Expected Pickup -->
                                <tr *ngIf="isNewRecordForDateOverhual">
                                  <td colspan="2" class="text-align-start pr-0 pt-0" [ngClass]="isOrderConfirmDelivery ? 'order-dateoverhaul' : null">
                                    <dynamic-date-form [form]="form" [class]="'parallel-radio-btn'" [entityId]="model?.id" [label]="metadata['customerExpectedPickupDates']" [minDate]="currentDateOnly"
                                      [formKey]="'customerExpectedPickupDates'" [isOrderConfirmDelivery]="isOrderConfirmDelivery"></dynamic-date-form>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td colspan="2" class="pl-3 pt-2 align-top" [ngClass]="!isOrderConfirmDelivery ? 'd-none' : null">
                              <table class="form-table">
                                <tr *ngIf="isOrderConfirmDelivery">
                                  <td class="text-align-start w-25">{{metadata['confirmReadyForDelivery']}}</td>
                                  <td class="text-align-start w-25">
                                    <simple-control [form]="form" key="confirmReadyForDelivery"
                                      [label]="metadata['confirmReadyForDelivery']" type="lookup" [items]="lookups.yesNoNull"
                                      [required]="true"></simple-control>
                                  </td>
                                </tr>
                                <tr *ngIf="isOrderConfirmDelivery">
                                  <td class="text-align-start">{{metadata['confirmedByReadyForDelivery']}}</td>
                                  <td class="text-align-start">
                                    <simple-control [form]="form" key="confirmedByReadyForDelivery" [label]="metadata['confirmedByReadyForDelivery']" type="text">
                                    </simple-control>
                                  </td>
                                </tr>
                                <tr *ngIf="isOrderConfirmDelivery">
                                  <td class="text-align-start">{{metadata['customerExpectedDelivery']}}</td>
                                  <td class="order-from-pd text-align-start">
                                    <simple-control [label]="metadata['customerExpectedDelivery']" [form]="form"
                                      key="customerExpectedDelivery" [readonly]="true" type="text"></simple-control>
                                  </td>
                                </tr>
                                <tr *ngIf="isNewRecordForDateOverhual && isOrderConfirmDelivery">
                                  <td colspan="2" class="text-align-start order-dateoverhaul pr-0 pt-0">
                                    <dynamic-date-form [form]="form" [class]="'parallel-radio-btn'" [entityId]="model?.id" [label]="metadata['customerExpectedDeliveryDates']" [minDate]="currentDateOnly"
                                      [formKey]="'customerExpectedDeliveryDates'" [isOrderConfirmDelivery]="isOrderConfirmDelivery"></dynamic-date-form>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr *ngIf="isOrderConfirmDelivery">
                      <td colspan="4">
                        <div class="form-table">
                          <div class="text-align-start mb-2">{{metadata['pickupDeliveryConfirmNotes']}}</div>
                          <div class="text-align-start">
                            <simple-control [form]="form" key="pickupDeliveryConfirmNotes" [label]="metadata['pickupDeliveryConfirmNotes']"
                              type="textarea" isCallback="true"></simple-control>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </ng-container>

                <ng-container *ngIf="status >= 2">
                  <tbody [hidden]="leftNavSelected != 'dispatch'">
                    <tr>
                      <td colspan="2" class="dispatch-page-border">
                        <table class="width-hundred">
                          <th id="order-form-dispatch" class="th-display-none"></th>
                          <tr>
                            <td class="carrier-text-alignment">Carrier</td>
                            <td class="dispatch-page-width">

                              <p-autoComplete dataKey="value" [formControl]="form.get('selectedCarrier')" field="label"
                                inputStyleClass="simple-control" [suggestions]="carrierItems" [style]="{'width': '100%'}" appendTo="body"
                                (completeMethod)="carrierSearch($event)" (onSelect)="carrierSelect($event.value)" (onClear)="onClearCarrier()"
                                forceSelection="true"></p-autoComplete>
                              <dynamic-control-error [formControl]="form.get('selectedCarrier')" [controlName]="'Carrier'"
                                ngDefaultControl></dynamic-control-error>

                              <div class="carrier-warning-message"  *ngIf="!hasActiveDriver && form.get('selectedCarrier').value && isNewRecordForTruckOverhual">
                                <img src="./assets/images/alert.svg" alt="alert-img" />
                                <div class="small-text italic" style="color:#b00; text-align: left; width: 100%; display: inline-block">Please select another carrier. This has no active
                                  driver.
                                </div>
                              </div>

                              <div class="carrier-warning-message"  *ngIf="isPolicyExpired && form.get('selectedCarrier').value">
                                <img src="./assets/images/alert.svg" alt="alert-img" />
                                <div class="small-text italic" style="color:#b00; text-align: left; width: 100%; display: inline-block"> The carrier policy has expired. Please select another carrier.</div>
                              </div>

                              <div class="carrier-warning-message"  *ngIf="isPolicyEmpty && form.get('selectedCarrier').value">
                                <img src="./assets/images/alert.svg" alt="alert-img" />
                                <div class="small-text italic" style="color:#b00; text-align: left; width: 100%; display: inline-block"> Please select another carrier. This carrier has no policy attached.</div>
                              </div>

                               <div class="carrier-warning-message"  *ngIf="!isTransitCompleteCarrier && form.get('selectedCarrier').value">
                                <img src="./assets/images/alert.svg" alt="alert-img" />
                                <div class="small-text italic" style="color:#b00; text-align: left; width: 100%; display: inline-block"> This carrier is not marked as Profile Complete. Please mark it or use another carrier.</div>
                              </div>

                              <div class="small-text italic" style="color:#b00; text-align: right; width: 100%; display: inline-block"
                                *ngIf="(form.controls['assignedCarrier']?.errors && form.controls['assignedCarrier']?.errors?.incorrect || isDoNotUseCarrier) && leftNavSelected == 'dispatch'">
                                <ng-container>
                                  <div class="carrier-warning-message justify-content-start">
                                    <img src="./assets/images/alert.svg" alt="alert-img"/>
                                    <div *ngIf="!isDoNotUseCarrier">{{form.controls['assignedCarrier']?.errors?.incorrect}}</div>
                                    <div *ngIf="isDoNotUseCarrier">Please select another carrier. This carrier mark as do not use.</div>
                                  </div>
                                </ng-container>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment dispatch-page-field-alignment">{{metadata['dispatcherName']}}</td>
                            <td class="dispatch-page-width">
                            <simple-control [form]="form" key="dispatcherName" [label]="metadata['dispatcherName']"
                            type="text"></simple-control>
                          </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment dispatch-field-alignment">{{metadata['dispatcherPhone']}}</td>
                            <td class="dispatch-page-width">
                            <simple-control [form]="form" key="dispatcherPhone" [label]="metadata['dispatcherPhone']"
                            type="phone"></simple-control>
                          </td>
                          </tr>
                        </table>
                      </td>
                      <td colspan="2" class="dispatch-page-border dispatch-field-padding-top">
                        <table class="width-hundred">
                          <th id="order-form-mcNumber" class="th-display-none"></th>
                          <tr>
                            <td class="width-thirty dispatch-field-alignment">MC #</td>
                            <td class="dispatch-page-items-spacing dispatch-page-width dispatch-field-alignment">
                            <span></span> {{mcNumber}}
                          </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment">{{metadata['dispatcherEmail']}}</td>
                            <td class="dispatch-page-width">
                            <simple-control [form]="form" key="dispatcherEmail" [label]="metadata['dispatcherEmail']"
                            type="email"></simple-control>
                          </td>
                          </tr>

                          <tr>
                            <td class="dispatch-field-alignment">Additional Carrier Emails</td>
                            <td class="order-from-pd dispatch-page-width">
                            <div>
                            <div *ngFor="let p of addlInfoArray('carrierEmails') let i=index" style="padding-bottom: 2px"> <input
                                appSanitizeInput style="width: 80%" pInputText type="text" [(ngModel)]="additionalInfo['carrierEmails'][i]"
                                #carrierEmail="ngModel" [ngModelOptions]="{standalone: true}" autocomplete="off" class="simple-control"
                                 (input)="validate_additional_emails('dispatch','carrierEmails')" [pattern]="email_pattern" />
                              <span><a (click)="confirmDelete('Carrier Email', i)" class="link-button"
                                  style="font-size: 16px; color: maroon !important">&nbsp;X</a></span>
                              <div *ngIf="carrierEmail.errors?.pattern" class="warrning-text-style"> <span style="font-size: 0.85em; color: #b00!important"> * Email is
                                  not a valid email address </span> </div>
                            </div>
                            <div class="add-info-spacing">
                              <a (click)="addAddlInfo('carrierEmails')" class="link-button">+ Add Email</a>
                            </div>
                            </div>
                            </td>
                          </tr>

                        </table>

                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="dispatch-page-border">
                        <table>
                          <th id="order-form-carrier-phone-numbers" class="th-display-none"></th>
                          <tr>
                            <td class="carrier-text-alignment">Carrier Phone Numbers:</td>
                            <td colspan="4" class="dispatch-readonly-font">
                              <div class="carrier-phones carrier-phone-spacing">
                                <div>
                                  <dynamic-value [type]="'phone'" [value]="businessPhone"></dynamic-value>
                                </div>
                                <div *ngFor="let p of assignedCarrierPhones">
                                  <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
                                </div>
                                <div>
                                  <dynamic-value [type]="'phone'" [value]="assignedCarrierPhone"></dynamic-value>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td colspan="2" class="dispatch-page-border">
                      @if (policyDetails.length > 0) {
                      <table class="width-hundred">
                        @for (policy of policyDetails; track $index; let last = $last) {
                        <tr>
                          <td colspan="4" class="policy-details-wrapper" [class.last-policy]="last">
                            <div class="broker-fee-width">
                              <b> {{ policy.policyName }}</b>
                            </div>
                            <div class="policy-details-section">
                              @for (cargo of policy.cargoLimit; track $index) {
                              <div class="d-flex">
                                <div class="policy-details-label">
                                  ${{ cargo.cargoInsuranceLimit | number:'1.2-2' }} ;
                                  @if (cargo.cargoInsuranceDeductible) {
                                  ${{ cargo.cargoInsuranceDeductible | number:'1.2-2' }}
                                  } @else {
                                  <span class="td-dynamic-data">—</span>
                                  }
                                </div>
                                <div [ngStyle]="{ color: cargo.isCargoInsuranceLimitExpire ? 'var(--dynamic-error)' : (cargo.isCargoInsuranceLimitAboutToExpire ? 'var(--dynamic-warning)' : 'var(--body-color)') }">
                                  Exp. {{ cargo.insuranceExpirationDate | date:'MM/dd/yy' : 'UTC' }}
                                  @if (cargo.isCargoInsuranceLimitExpire) {
                                  <span style="color: var(--dynamic-error); font-style: italic;"> Policy
                                    Expired</span>
                                  } @else if (cargo.isCargoInsuranceLimitAboutToExpire) {
                                  <span style="color: var(--dynamic-warning); font-style: italic;"> Policy
                                    About to Expire</span>
                                  }
                                </div>
                              </div>
                              }
                              @for (liability of policy.liabilityLimit; track $index) {
                              <div class="d-flex">
                                <div class="policy-details-label">
                                  ${{ liability.liabilityLimit | number:'1.2-2' }}
                                </div>
                                <div [ngStyle]="{ color: liability.isLiabilityLimitExpire ? 'var(--dynamic-error)' : (liability.isLiabilityLimitAboutToExpire ? 'var(--dynamic-warning)' : 'var(--body-color)') }">
                                  Exp. {{ liability.liabilityExpirationDate | date:'MM/dd/yy' : 'UTC' }}
                                  @if (liability.isLiabilityLimitExpire) {
                                  <span style="color: var(--dynamic-error); font-style: italic;">
                                    Policy Expired</span>
                                  } @else if (liability.isLiabilityLimitAboutToExpire) {
                                  <span style="color: var(--dynamic-warning); font-style: italic;">
                                    Policy About to Expire</span>
                                  }
                                </div>
                              </div>
                              }
                            </div>
                          </td>
                        </tr>
                        }
                      </table>
                      } @else {
                      <table class="width-hundred">
                        <tr>
                          <td class="carrier-text-alignment">Policy Details: —  — </td>
                        </tr>
                      </table>
                      }
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="dispatch-page-border pr-1">
                        <table class="width-hundred" *ngIf="!isNewRecordForTruckOverhual">
                          <th id="order-form-driverName" class="th-display-none"></th>
                          <tr>
                            <td class="carrier-text-alignment dispatch-page-field-alignment ready-dispatch-width">{{metadata['driverName']}}</td>
                            <td class="dispatch-page-width">
                            <simple-control simple-control [form]="form" key="driverName" [label]="metadata['driverName']" type="text">
                            </simple-control>
                            </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment dispatch-page-field-alignment">{{metadata['driverPhone']}}</td>
                            <td class="dispatch-page-width">
                              <simple-control [form]="form" key="driverPhone" [label]="metadata['driverPhone']" type="phone">
                              </simple-control>
                            </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment dispatch-page-field-alignment">{{metadata['trailerSize']}}</td>
                            <td class="dispatch-page-width">
                            <simple-control [form]="form" key="trailerSize" [label]="metadata['trailerSize']" type="text">
                            </simple-control>
                          </td>
                          </tr>
                        </table>
                        <table class="width-hundred" *ngIf="isNewRecordForTruckOverhual">
                          <tr>
                            <driver-truck-form [form]="form"  [formKey]="'orderDriverDetail'" [carrierData]="form.get('selectedCarrier')?.value" [noOfRequireDateFields]="1"  (noActiveDriverFlagChange)="onNoActiveDriverFlagChange($event)" (policyData)="onPolicyDetailsChange($event)"></driver-truck-form>
                          </tr>
                        </table>
                      </td>
                      <td colspan="2" class="dispatch-page-border vertical-alignment-top">
                        <table class="width-hundred">
                          <th id="order-form-driverPhone" class="th-display-none"></th>
                          <tr>
                            <td class="carrier-text-alignment dispatch-page-field-alignment">{{metadata['priceToCarrier']}}</td>
                            <td class="dispatch-page-width dispatch-page-items-spacing ">
                            <simple-control [form]="form" key="priceToCarrier" [label]="metadata['priceToCarrier']"
                            type="currency" (onChange)="customerChargedTypeChanged()"></simple-control>
                          </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment dispatch-field-alignment">{{metadata['paymentTerms']}}</td>
                            <td class="dispatch-page-items-spacing dispatch-page-width order-from-pd">
                              <simple-control [form]="form" key="paymentTerms" [label]="metadata['paymentTerms']"
                                type="lookup" [items]="lookups.paymentTerms" [readonly]="isPaymentTermsReadOnly"
                                [readonlyLabel]="'N/A'"></simple-control>
                            </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment">{{metadata['brokerFee']}}</td>
                            <td class="dispatch-page-width order-from-pd text-align-start dispatch-page-items-spacing ">
                              <simple-control *ngIf="form.get('brokerFee')?.value != null" [form]="form" key="brokerFee"
                                [label]="metadata['brokerFee']" type="currency" [readonly]="true"></simple-control>
                              <div *ngIf="form.get('brokerFee')?.value == null" style="padding: 4px;">N/A</div>
                            </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment">{{metadata['brokerFeePaid']}}</td>
                            <td class="order-from-pd dispatch-page-items-spacing dispatch-page-width">
                            <simple-control [form]="form" key="brokerFeePaid" [label]="metadata['brokerFeePaid']"
                            type="lookup" [items]="lookups.yesNoNa" [readonly]="this.form.get('brokerFee')?.value == null "
                            (onChange)="calculateCompanyProfit()"></simple-control>
                          </td>
                          </tr>
                          <tr *ngIf="form?.get('brokerFeePaid')?.value == YesNoNA.Yes">
                            <td class="carrier-text-alignment">{{metadata['brokerFeePaidDate']}}</td>
                            <td class="order-from-pd dispatch-page-width dispatch-page-items-spacing ">
                            <simple-control [form]="form" key="brokerFeePaidDate" [label]="metadata['brokerFeePaidDate']" type="date"
                            (onChange)="calculateCompanyProfit()"></simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="form?.get('brokerFeePaid')?.value == YesNoNA.Yes">
                            <td class="carrier-text-alignment dispatch-field-alignment">{{metadata['brokerFeePaymentMethod']}}</td>
                            <td class="dispatch-page-width dispatch-page-items-spacing">
                              <simple-control [form]="form" key="brokerFeePaymentMethod" [label]="metadata['brokerFeePaymentMethod']"
                                type="lookup" [items]="lookups.paymentMethod" (onChange)="calculateCompanyProfit()">
                              </simple-control>
                            </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment">Price To Carrier (Adjusted)</td>
                            <td class="dispatch-page-width dispatch-page-items-spacing order-from-pd">
                            <simple-control [form]="form" key="calculatedPriceToCarrier" label="Price To Carrier (Adjusted)"
                            type="currency" [readonly]="true"></simple-control>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <table style="width: 100%;">
                                <th id="order-form-desiredProfit" class="th-display-none"></th>
                                <tr *ngIf="showDesiredProfit">
                                  <td class="carrier-text-alignment add-info-spacing"><div class="desired-profit-width"
                                      [style.background]="form.get('desiredProfit')?.value?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['desiredProfit']}}</div>
                                  </td>
                                  <td class="dispatch-page-width dispatch-page-items-spacing">
                                    <simple-control [class]="form.get('desiredProfit')?.value?.length > 0 ? 'yellow-bg' : ''"
                                      [label]="metadata['desiredProfit']" [form]="form" key="desiredProfit" type="currency"
                                      [readonly]="true"></simple-control>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td class="carrier-text-alignment">Company Profit</td>
                            <td class="order-from-pd dispatch-page-items-spacing dispatch-page-width">
                            <simple-control [form]="form" key="calculatedCompanyProfit" label="Company Profit"
                            type="currency" [readonly]="true"></simple-control>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <!-- date-overhaul for Customer Expected Pickup (Read only) -->
                    <tr class="date-overhaul-record">
                      <td colspan="2" class="dispatch-page-border">
                        <table class="width-hundred">
                          <th id="order-form-customerExpectedPickup" class="th-display-none"></th>
                          <tr class="customer-expected">
                            <td class="carrier-text-alignment pickupdetails-width pt-0">{{metadata['customerExpectedPickup']}}</td>
                            <td class="order-from-pd dispatch-readonly-font">
                              <simple-control [form]="form" key="customerExpectedPickup" label="Scheduled Pickup Date"
                              type="text" [readonly]="true"></simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="isNewRecordForDateOverhual" >
                            <div *ngFor="let customerExpectedPickupDate of form.get('customerExpectedPickupDates')?.value; let i =     index;">
                              <td class="carrier-text-alignment pickupdetails-width">{{metadata['customerExpectedPickupDates']}} {{i+1}}</td>
                              <td class="dispatch-readonly-font">
                                <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedPickupDate }"></ng-template>
                              </td>
                            </div>
                          </tr>
                        </table>
                      </td>
                      <td colspan="2" class="dispatch-page-border">
                        <table class="width-hundred">
                          <th id="order-form-customerExpectedDelivery" class="th-display-none"></th>
                          <tr class="new-records-main">
                            <td class="customer-expected-delivery field-spacing carrier-text-alignment dateformat-label-width">{{metadata['customerExpectedDelivery']}}</td>
                            <td>
                              <simple-control [label]="metadata['customerExpectedDelivery']" [form]="form"
                                key="customerExpectedDelivery" type="text" [readonly]="true"></simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="isNewRecordForDateOverhual && !isOrderConfirmDelivery">
                            <td class="carrier-text-alignment">
                              <dynamic-date-form [form]="form" [class]="'parallel-radio-btn'" [entityId]="model?.id" [label]="metadata['customerExpectedDeliveryDates']" [minDate]="currentDateOnly"
                                [formKey]="'customerExpectedDeliveryDates'" [noOfRequireDateFields]="!isOrderConfirmDelivery ? 0 : 1"  [isOrderConfirmDelivery]="isOrderConfirmDelivery"></dynamic-date-form>
                            </td>
                          </tr>
                          <tr *ngIf="isNewRecordForDateOverhual && isOrderConfirmDelivery" >
                            <div *ngFor="let customerExpectedDeliveryDates of form.get('customerExpectedDeliveryDates')?.value; let i = index;">
                              <td class="carrier-text-alignment pickupdetails-width">{{metadata['customerExpectedDeliveryDates']}} {{i+1}}</td>
                              <td class="dispatch-readonly-font">
                                <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedDeliveryDates }"></ng-template>
                              </td>
                            </div>
                          </tr>
                          <tr *ngIf="scheduledDateChanged && !isNewRecordForDateOverhual">
                            <td>{{metadata['scheduledChangeReason']}}</td>
                            <td>
                              <simple-control [form]="form" key="scheduledChangeReason"
                                [label]="metadata['scheduledChangeReason']" type="text"></simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="scheduledDateChanged && !isNewRecordForDateOverhual">
                            <td></td>
                            <td style="text-align: left; padding-bottom: 8px">
                              <img src="./assets/images/warning.svg" height="16" alt="warning" class="filter-invert" /><span
                                class="muted7 italic small-text" style="padding-left: 8px;">Evaluate Transport Results and
                                indicate if the delivery is
                                late</span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="dispatch-page-border">
                        <table class="width-hundred">
                          <th id="order-form-carrierScheduledPickupDates" class="th-display-none"></th>
                          <tr *ngIf="isNewRecordForDateOverhual" class="carrier-text-alignment">
                            <td>
                              <dynamic-date-form [form]="form" [class]="'parallel-radio-btn'" [entityId]="model?.id"
                                [label]="metadata['carrierScheduledPickupDates']"
                                [formKey]="'carrierScheduledPickupDates'"  [isOrderConfirmDelivery]="isOrderConfirmDelivery"></dynamic-date-form>
                            </td>
                          </tr>
                          <tr class="new-records-main">
                            <td class="carrier-pickup-datenote carrier-text-alignment date-format-width field-spacing">{{isNewRecordForDateOverhual ? metadata['carrierPickupDateNote'] :
                              metadata['scheduledPickup']}}</td>
                            <td class="carrier-pickup-datenote-key dispatch-page-width">
                              <simple-control [form]="form" key="scheduledPickup" [label]="metadata['scheduledPickup']"
                                type="text"></simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="scheduledDateChanged && !isNewRecordForDateOverhual">
                            <td>{{metadata['pickupConfirmationDate']}}</td>
                            <td>
                              <simple-control [form]="form" key="pickupConfirmationDate" [label]="metadata['pickupConfirmationDate']"
                                type="date"></simple-control>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td colspan="2" class="dispatch-page-border vertical-alignment-top">
                        <table class="width-hundred">
                          <th id="order-form-carrierScheduledDeliveryDates" class="th-display-none"></th>
                          <tr *ngIf="isNewRecordForDateOverhual" class="carrier-text-alignment">
                            <td>
                              <dynamic-date-form [form]="form" [class]="'parallel-radio-btn'" [entityId]="model?.id"
                                [label]="metadata['carrierScheduledDeliveryDates']"
                                [formKey]="'carrierScheduledDeliveryDates'" [isOrderConfirmDelivery]="isOrderConfirmDelivery"></dynamic-date-form>
                            </td>
                          </tr>
                          <tr class="new-records-main">
                            <td class="carrier-pickup-datenote carrier-text-alignment date-format-width field-spacing">{{isNewRecordForDateOverhual ? metadata['carrierDeliveryDateNote'] : metadata['scheduledDelivery']}}</td>
                            <td class="carrier-pickup-datenote-key dispatch-page-width">
                              <simple-control [form]="form" key="scheduledDelivery" [label]="metadata['scheduledDelivery']"
                                type="text"></simple-control>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="text-align-left">
                        <div class="bill-port-input-checkbox">
                        <input type="checkbox" [checked]="this.form.get('includeBoL').value" (change)="this.form.get('includeBoL').setValue(!this.form.get('includeBoL').value)" /> Include Bill of Lading&nbsp;&nbsp;
                        <input type="checkbox" [checked]="this.form.get('includePort').value" (change)="this.form.get('includePort').setValue(!this.form.get('includePort').value)" />
                        Include Port Additional Terms?
                      </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="text-align-left">
                        <input type="checkbox" [checked]="this.form.get('includeRidgeville').value" (change)="this.form.get('includeRidgeville').setValue(!this.form.get('includeRidgeville').value)" />
                        Include Ridgeville Additional Terms?
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <a *ngIf="!isDownloadingCarrierTerms" style="float: left;" class="link-button"
                          (click)="downloadCarrierTerms()">Download Carrier Terms</a>
                        <a *ngIf="isDownloadingCarrierTerms" style="float: left; color: #444 !important;"
                          class="link-button">Download Carrier Terms</a>
                        <span style="float: left; padding-left: 5px;" *ngIf="isDownloadingCarrierTerms"><i
                            class="fa fa-spinner fa-spin"></i></span>
                      </td>
                    </tr>
                  </tbody>
                </ng-container>

                <ng-container *ngIf="status >= 3">
                  <tbody [hidden]="leftNavSelected != 'pickupDetails'">
                    <!-- date-overhaul Customer Expected Pickup (Read only) -->
                    <tr>
                      <td colspan="2" class="w-fifty field-spacing">
                        <table class="width-hundred">
                          <th id="order-form-pickupDetails" class="th-display-none"></th>
                          <div class="pickup-details-bg">
                            <tr>
                              <td class="text-align-start pickupdetails-width">{{metadata['customerExpectedPickup']}}</td>
                              <td class="order-from-pd">
                                <simple-control [ngContainerDivClass]="'edit-spacing'" [label]="metadata['customerExpectedPickup']" [form]="form" key="customerExpectedPickup"
                                  [readonly]="true" type="text"></simple-control>
                              </td>
                            </tr>
                            <div *ngIf="isNewRecordForDateOverhual">
                              <tr *ngFor="let customerExpectedPickupDate of form.get('customerExpectedPickupDates')?.value; let i = index;">
                                <td class="carrier-text-alignment pickupdetails-width">{{metadata['customerExpectedPickupDates']}} {{i+1}}</td>
                                <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedPickupDate }"></ng-template>
                              </tr>
                            </div>
                            <!-- date-overhaul Carrier Scheduled Pickup Start/End (Read only) -->
                            <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record text-align-start">
                              <tr *ngFor="let carrierScheduledPickupDate of form.get('carrierScheduledPickupDates')?.value; let i = index;">
                                <td class="text-align-start pickupdetails-width">{{metadata['carrierScheduledPickupDates']}} {{i+1}}</td>
                                <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: carrierScheduledPickupDate }"></ng-template>
                              </tr>
                            </div>
                            <!-- Carrier Scheduled Pickup text field -->
                            <tr *ngIf="isNewRecordForDateOverhual">
                              <td class="text-align-start pickupdetails-width">{{metadata['carrierPickupDateNote']}}</td>
                              <td class="order-from-pd text-align-start">
                                <simple-control [ngContainerDivClass]="'edit-spacing'" [label]="metadata['scheduledPickup']" [form]="form" key="scheduledPickup" [readonly]="true"
                                  type="text"></simple-control>
                              </td>
                            </tr>
                          </div>
                        </table>
                      </td>
                    <td colspan="2" class="w-fifty vertical-alignment-top pickup-details-bg">
                      <!-- date-overhaul for Customer Expected Delivery (Read only) -->
                      <table class="width-hundred">
                        <th id="order-form-pickup-details-customerExpectedDelivery" class="th-display-none"></th>
                        <div class="pickup-details-bg">
                          <tr>
                            <td class="text-align-start pickupdetails-width">{{metadata['customerExpectedDelivery']}}</td>
                            <td class="order-from-pd">
                              <simple-control [ngContainerDivClass]="'edit-spacing'" [label]="metadata['customerExpectedDelivery']" [form]="form" key="customerExpectedDelivery"
                                type="text" [readonly]="true"></simple-control>
                            </td>
                          </tr>
                          <div *ngIf="isNewRecordForDateOverhual">
                            <tr *ngFor="let customerExpectedDeliveryDate of form.get('customerExpectedDeliveryDates')?.value; let i = index;">
                              <td class="carrier-text-alignment pickupdetails-width">{{metadata['customerExpectedDeliveryDates']}} {{i+1}}</td>
                              <ng-template
                                *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedDeliveryDate }"></ng-template>
                            </tr>
                          </div>
                          <!-- date-overhaul Carrier Scheduled Delivery Start/End (Read only) -->
                          <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                            <tr *ngFor="let carrierScheduledDeliveryDate of form.get('carrierScheduledDeliveryDates')?.value; let i = index;">
                              <td class="carrier-text-alignment pickupdetails-width">{{metadata['carrierScheduledDeliveryDates']}} {{i+1}}</td>
                              <ng-template
                                *ngTemplateOutlet="dateoverhaul; context: { $implicit: carrierScheduledDeliveryDate }"></ng-template>
                            </tr>
                          </div>
                          <tr *ngIf="isNewRecordForDateOverhual">
                            <td class="text-align-start pickupdetails-width">{{metadata['carrierDeliveryDateNote']}}</td>
                            <td class="order-from-pd text-align-start">
                              <simple-control [ngContainerDivClass]="'edit-spacing'" [label]="metadata['scheduledDelivery']" [form]="form" key="scheduledDelivery" [readonly]="true"
                                type="text"></simple-control>
                            </td>
                          </tr>
                        </div>
                      </table>
                    </td>
                  </tr>
                  <tr>
                      <td colspan="4" class="carrier-scheduled-delivery-spacing padding-rigth-zero">
                        <table class="width-hundred d-flex">
                          <th id="order-form-actualPickupDate" class="th-display-none"></th>
                          <div class="carrier-scheduled-delivery w-50">
                            <!-- Carrier Scheduled Delivery text field -->
                            <tr>
                              <td style="width: 190px;">{{metadata['actualPickupDate']}}</td>
                              <td class="text-align-start">
                                <simple-control [form]="form" key="actualPickupDate" [class]="'width-sixtyfive'"
                                  [label]="metadata['actualPickupDate']" type="datetime" [maxDate]="now"></simple-control>
                              </td>
                            </tr>
                            <tr>
                              <td>{{metadata['pickupConfirmedBy']}}</td>
                              <td class="text-align-start">
                                <simple-control [form]="form" key="pickupConfirmedBy" [class]="'width-sixtyfive'"
                                  [label]="metadata['pickupConfirmedBy']" type="text"></simple-control>
                              </td>
                            </tr>
                            <tr>
                              <td>{{metadata['pickupCarrierTransportResult']}}</td>
                              <td class="pickup-details-dropdown text-align-start">
                                <p-multiSelect styleClass="simple-control width-sixtyfive" appendTo="body" [showToggleAll]="false" (onChange)="onTransportResultDropDownSelect('carrierTransportResults',$event.value)"
                                  [options]="lookups.carrierTransportResults" [formControl]="form.get('pickupCarrierTransportResult')" [maxSelectedLabels]="500">
                                </p-multiSelect>
                                <dynamic-control-error [formControl]="form.get('pickupCarrierTransportResult')"
                                  [controlName]="metadata['pickupCarrierTransportResult']" ngDefaultControl></dynamic-control-error>
                              </td>
                            </tr>
                            <tr>
                              <td>{{metadata['pickupFSCTransportResult']}}</td>
                              <td class="pickup-details-dropdown text-align-start">
                                <p-multiSelect styleClass="simple-control width-sixtyfive" appendTo="body" [showToggleAll]="false" (onChange)="onTransportResultDropDownSelect('fscTransportResults',$event.value)"
                                  [options]="lookups.fscTransportResults" [formControl]="form.get('pickupFSCTransportResult')" [maxSelectedLabels]="500">
                                </p-multiSelect>
                                <dynamic-control-error [formControl]="form.get('pickupFSCTransportResult')"
                                  [controlName]="metadata['pickupFSCTransportResult']" ngDefaultControl></dynamic-control-error>
                              </td>
                            </tr>
                            <tr>
                              <td>{{metadata['callback1']}}</td>
                              <td  class="text-align-start">
                                <simple-control [label]="metadata['callback1']" [class]="'width-sixtyfive'" [form]="form"
                                key="callback1" (change)="this.form.get('callback1').setValue(!this.form.get('callback1').value)" type="boolean">
                              </simple-control>
                              </td>
                            </tr>
                            <tr *ngIf="this.form.get('callback1').value == true">
                              <td>{{metadata['callback1date']}}</td>
                              <td class="text-align-start">
                                <simple-control [class]="'width-sixtyfive'" [form]="form" key="callback1date" [label]="metadata['callback1date']"
                                type="datetimewithsec"></simple-control>
                              </td>
                            </tr>
                            <tr *ngIf="this.form.get('callback1').value == true">
                              <td>{{metadata['callback1note']}}</td>
                              <td>
                                <simple-control [form]="form" key="callback1note" [label]="metadata['callback1note']"
                                type="textarea" isCallback="true"></simple-control>
                              </td>
                            </tr>
                            <tr *ngIf="isNewRecordForDateOverhual">
                              <td>{{metadata['isPickupNewETA']}}</td>
                              <td class="text-align-start">
                                <simple-control [label]="metadata['isPickupNewETA']" [class]="'width-sixtyfive'" [form]="form"
                                  key="isPickupNewETA" type="boolean">
                                </simple-control>
                              </td>
                            </tr>
                            <tr *ngIf="isNewRecordForDateOverhual && form.get('isPickupNewETA').value">
                              <td colspan="2">
                                <dynamic-date-form class="date-format-neweta pickupdetail-removebtn" [form]="form"
                                  [class]="'parallel-radio-btn'" (onDateChange)="onDateChange($event)" [entityId]="model?.id"
                                  [label]="metadata['pickupNewETADates']" [formKey]="'pickupNewETADates'"  [isOrderConfirmDelivery]="isOrderConfirmDelivery"></dynamic-date-form>
                              </td>
                            </tr>
                            <tr *ngIf="isNewRecordForDateOverhual && form.get('isPickupNewETA').value">
                              <td>{{metadata['pickupNewETAReason']}}</td>
                              <td class="text-align-start">
                                <simple-control [label]="metadata['pickupNewETAReason']" [class]="'width-sixtyfive'" [form]="form"
                                  key="pickupNewETAReason" type="text">
                                </simple-control>
                              </td>
                            </tr>
                            <tr *ngIf="isNewRecordForDateOverhual">
                              <td>{{metadata['isDeliveryNewETA']}}</td>
                              <td style="text-align: start;">
                                <simple-control [label]="metadata['isDeliveryNewETA']" [form]="form" key="isDeliveryNewETA" type="boolean">
                                </simple-control>
                              </td>
                            </tr>
                            <tr *ngIf="isNewRecordForDateOverhual && form.get('isDeliveryNewETA').value">
                              <td colspan="2">
                                <dynamic-date-form [form]="form" [class]="'parallel-radio-btn'" class="date-format-neweta pickupdetail-removebtn" (onDateChange)="onDateChange($event)"
                                  [entityId]="model?.id" [label]="metadata['deliveryNewETADates']"
                                  [formKey]="'deliveryNewETADates'" [isOrderConfirmDelivery]="isOrderConfirmDelivery" ></dynamic-date-form>
                              </td>
                            </tr>
                            <tr *ngIf="isNewRecordForDateOverhual && form.get('isDeliveryNewETA').value">
                              <td>{{metadata['deliveryNewETAReason']}}</td>
                              <td class="text-align-start">
                                <simple-control [label]="metadata['deliveryNewETAReason']" [class]="'width-sixtyfive'" [form]="form"
                                  key="deliveryNewETAReason" type="text">
                                </simple-control>
                              </td>
                            </tr>
                          </div>
                          <div class="carrier-scheduled-delivery pl-1 w-50">
                            <div class="communication-title">{{metadata['communicationPreferences']}}</div>
                            <div class="text-align-start communication-para">
                              <simple-control [form]="form" key="communicationPreferences" [label]="metadata['communicationPreferences']"
                                type="textarea" [readonly]="true" [class]="'width-sixtyfive'" [rows]="3">
                              </simple-control>
                            </div>
                          </div>
                        </table>
                      </td>
                  </tr>
                  </tbody>
                </ng-container>

                <ng-container *ngIf="status >= 4">
                  <tbody [hidden]="leftNavSelected != 'deliveryDetails'">
                    <!-- date-overhaul for Customer Expected Delivery (Read only) -->
                    <tr>
                      <td colspan="2">
                        <table class="width-hundred pickup-details-bg">
                          <tr>
                            <td class="width-fourty">{{metadata['customerExpectedDelivery']}}</td>
                            <td class="order-from-pd text-align-left">
                              <simple-control [ngContainerDivClass]="'edit-spacing'" [label]="metadata['customerExpectedDelivery']" [form]="form"
                                key="customerExpectedDelivery" type="text" [readonly]="true"></simple-control>
                            </td>
                          </tr>
                          <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                            <tr *ngFor="let customerExpectedDeliveryDate of form.get('customerExpectedDeliveryDates')?.value; let i = index;">
                              <td>{{metadata['customerExpectedDeliveryDates']}} {{i+1}}</td>
                              <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedDeliveryDate }"></ng-template>
                            </tr>
                          </div>
                          <!-- date-overhaul Carrier Scheduled Delivery Start/End (Read only) -->
                          <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                            <tr *ngFor="let carrierScheduledDeliveryDate of form.get('carrierScheduledDeliveryDates')?.value; let i = index;">
                              <td>{{metadata['carrierScheduledDeliveryDates']}} {{i+1}}</td>
                              <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: carrierScheduledDeliveryDate }"></ng-template>
                            </tr>
                          </div>
                          <!-- Carrier Scheduled Delivery text field -->
                          <tr *ngIf="isNewRecordForDateOverhual">
                            <td>{{metadata['carrierDeliveryDateNote']}}</td>
                            <td class="order-from-pd text-align-left">
                              <simple-control [ngContainerDivClass]="'edit-spacing'" [label]="metadata['scheduledDelivery']" [form]="form" key="scheduledDelivery" [readonly]="true"
                                type="text"></simple-control>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  <tr>
                    <td colspan="4" class="carrier-scheduled-delivery-spacing padding-rigth-zero">
                      <table class="width-hundred pickup-details-bg d-flex">
                        <div class="carrier-scheduled-delivery pl-1 w-50">
                          <tr>
                            <td class="width-fourty">{{metadata['actualDeliveryDate']}}</td>
                            <td class="text-align-left">
                              <simple-control  [form]="form" key="actualDeliveryDate"
                                [label]="metadata['actualDeliveryDate']" type="datetime" [readonlyInput]="true"
                                [maxDate]="now"></simple-control>
                            </td>
                          </tr>
                          <tr>
                            <td>{{metadata['deliveryConfirmedBy']}}</td>
                            <td class="text-align-left">
                              <simple-control [form]="form" key="deliveryConfirmedBy"
                                [label]="metadata['deliveryConfirmedBy']" type="text"></simple-control>
                            </td>
                          </tr>
                          <tr>
                            <td>{{metadata['pickupCarrierTransportResult']}}</td>
                            <td class="date-overhaul-spacing text-align-left">
                              <dynamic-value [type]="'text'" [value]="pickupCarrierLabel"></dynamic-value>
                            </td>
                          </tr>
                          <tr>
                            <td>{{metadata['pickupFSCTransportResult']}}</td>
                            <td class="date-overhaul-spacing  text-align-left">
                              <dynamic-value [type]="'text'" [value]="pickupFSCLabel"></dynamic-value>
                            </td>
                          </tr>
                          <tr>
                            <td>{{metadata['deliveryCarrierTransportResult']}}</td>
                            <td class="order-transport-result-dropdown text-align-left">
                              <p-multiSelect styleClass="simple-control transport-results-width" appendTo="body" [showToggleAll]="false"
                                (onChange)="onTransportResultDropDownSelect('deliveryCarrierTransportResults',$event.value)"
                                [options]="lookups.deliveryCarrierTransportResults" [formControl]="form.get('deliveryCarrierTransportResult')"
                                [maxSelectedLabels]="500">
                              </p-multiSelect>
                              <dynamic-control-error [formControl]="form.get('deliveryCarrierTransportResult')"
                                [controlName]="metadata['deliveryCarrierTransportResult']" ngDefaultControl></dynamic-control-error>
                            </td>
                          </tr>
                          <tr>
                            <td>{{metadata['deliveryFSCTransportResult']}}</td>
                            <td class="order-transport-result-dropdown text-align-left">
                              <p-multiSelect styleClass="simple-control transport-results-width" appendTo="body" [showToggleAll]="false"
                                (onChange)="onTransportResultDropDownSelect('deliveryfscTransportResults',$event.value)"
                                [options]="lookups.deliveryfscTransportResults" [formControl]="form.get('deliveryFSCTransportResult')"
                                [maxSelectedLabels]="500">
                              </p-multiSelect>
                              <dynamic-control-error [formControl]="form.get('deliveryFSCTransportResult')"
                                [controlName]="metadata['deliveryFSCTransportResult']" ngDefaultControl></dynamic-control-error>
                            </td>
                          </tr>
                          <tr *ngIf="this.form.get('callback1').value == true">
                            <td>{{metadata['callback1note']}}</td>
                            <td class="text-align-start
                                                order-from-pd">
                              <simple-control [form]="form" key="callback1note" [label]="metadata['callback1note']" type="textarea"
                                [readonly]="true" [class]="'callback-readonly-height callback-inputbox'" isCallback="true"></simple-control>
                            </td>
                          </tr>
                          <tr>
                            <td>{{metadata['callback2']}}</td>
                            <td class="text-align-start">
                              <simple-control [label]="metadata['callback2']" [form]="form" key="callback2"
                                (change)="this.form.get('callback2').setValue(!this.form.get('callback2').value)" type="boolean">
                              </simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="this.form.get('callback2').value == true">
                            <td>{{metadata['callback2date']}}</td>
                            <td class="text-align-start">
                              <simple-control [form]="form" key="callback2date"
                                [label]="metadata['callback2date']" type="datetimewithsec"></simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="this.form.get('callback2').value == true">
                            <td>{{metadata['callback2note']}}</td>
                            <td>
                              <simple-control [form]="form" key="callback2note" [label]="metadata['callback2note']" type="textarea"
                                isCallback="true"></simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="isNewRecordForDateOverhual">
                            <td>{{metadata['isDeliveryNewETAForDeliveryDetails']}}</td>
                            <td class="text-align-left">
                              <simple-control [label]="metadata['isDeliveryNewETAForDeliveryDetails']" [form]="form"
                                key="isDeliveryNewETAForDeliveryDetails" type="boolean">
                              </simple-control>
                            </td>
                          </tr>
                          <tr *ngIf="isNewRecordForDateOverhual && form.get('isDeliveryNewETAForDeliveryDetails').value">
                            <td colspan="2">
                              <dynamic-date-form [form]="form" [class]="'parallel-radio-btn'" (onDateChange)="onDateChange($event)"
                                [entityId]="model?.id" [label]="metadata['deliveryNewETADates']" [formKey]="'deliveryNewETADates'"
                                [isOrderConfirmDelivery]="isOrderConfirmDelivery"></dynamic-date-form>
                            </td>
                          </tr>
                          <tr *ngIf="isNewRecordForDateOverhual && form.get('isDeliveryNewETAForDeliveryDetails').value">
                            <td>{{metadata['deliveryNewETAReason']}}</td>
                            <td class="text-align-left">
                              <simple-control [label]="metadata['deliveryNewETAReason']" [form]="form"
                                key="deliveryNewETAReason" type="text">
                              </simple-control>
                            </td>
                          </tr>
                        </div>
                         <div class="carrier-scheduled-delivery pl-1 w-50">
                            <div class="communication-title">{{metadata['communicationPreferences']}}</div>
                            <div class="text-align-start communication-para">
                              <simple-control [form]="form" key="communicationPreferences" [label]="metadata['communicationPreferences']"
                                type="textarea" [readonly]="true" [class]="'width-sixtyfive'" [rows]="3">
                              </simple-control>
                            </div>
                          </div>
                      </table>
                    </td>
                  </tr>
                  </tbody>
                </ng-container>

              </table>

              <!-- vehicles -->
              <ng-container *ngIf="leftNavSelected == 'vehicles'">
                <vehicles-form [form]="form" (countChange)="countChange('vehicles', $event)" (vehicleUpdate)="vehicleUpdate($event)"
                [readonly]="false" [allowAdd]="!formSettings.disableVehicles"></vehicles-form>
                <div *ngIf="form.contains('vehicles') && form.get('vehicles').length < 1" class="small-text italic"
                  style="color:#b00; text-align: right; width: 100%; display: inline-block">
                  <img alt="alert" src="./assets/images/alert.svg"/> Please add at least 1 vehicle
                </div>
              </ng-container>

              <!-- notes -->
              <div *ngIf="!isAdding || true" [hidden]="leftNavSelected != 'notes'" class="notes-detail-width">
                <notes [status]="status" [entityName]="'Order'" [entityId]="model.id" (rowsChange)="newNotes = $event"></notes>
              </div>

              <!-- attachments -->
              <div [hidden]="leftNavSelected != 'documents'">
                <uploads [orderId]="model?.id" [orderGuid]="model?.guid" (rowsChange)="changeUploads($event)" [isOrderDoc]="true"
                  [addLabel]="status == 2 ? 'Add Dispatch Document' : 'Add Document'"></uploads>
              </div>

              <!-- customer contacts -->
              <ng-container *ngIf="leftNavSelected == 'customer'">

                <ng-container *ngIf="isAdding; else edit">
                  <ng-container *ngIf="isPrivateCustomer; else nonprivate">
                    <contacts-form [entityId]="0" entityName="Order" [form]="form" formKey="contacts" 
                    [isAddContactEnabled$]="isAddContactEnabled$" (onReachMaxContact)="onReachMaxContact($event)"></contacts-form>
                  </ng-container>
                  <ng-template #nonprivate>
                    <ng-container *ngIf="isNewClient; else existingclient">
                      <contacts-form [entityId]="0" entityName="Order" [form]="form" formKey="contacts" [isAddContactEnabled$]="isAddContactEnabled$" (onReachMaxContact)="onReachMaxContact($event)"></contacts-form>
                    </ng-container>
                    <ng-template #existingclient>
                      <contacts-form [entityId]="0" entityName="Order" [form]="form" formKey="contacts" (removeContactId)="removeContactId($event)" [isAddContactEnabled$]="isAddContactEnabled$" (onReachMaxContact)="onReachMaxContact($event)"></contacts-form>
                    </ng-template>
                  </ng-template>
                </ng-container>

                <ng-template #edit>
                  <ng-container *ngIf="isPrivateCustomer; else nonprivate">
                    <contacts-form [entityId]="0" entityName="Order" [form]="form" formKey="contacts" [isAddContactEnabled$]="isAddContactEnabled$"></contacts-form>
                    <!--N/A-->
                  </ng-container>
                  <ng-template #nonprivate>
                    <contacts-form [entityId]="model?.id" entityName="Order" [form]="form" formKey="contacts" (removeContactId)="removeContactId($event)" [isAddContactEnabled$]="isAddContactEnabled$"></contacts-form>
                  </ng-template>

                </ng-template>

              </ng-container>

              <ng-container
                *ngIf="leftNavSelected == 'pickup'">
                <ng-container *ngIf="isAdding; else edit">
                  <contacts-form [entityId]="0" entityName="OrderPickup" [form]="form" formKey="pickupContacts" (removeContactId)="removeContactId($event)" 
                  [isAddContactEnabled$]="isAddPickupContactEnabled$" (onReachMaxContact)="onReachMaxContact($event)">
                  </contacts-form>
                </ng-container>
                <ng-template #edit>
                  <contacts-form [entityId]="model?.id" entityName="OrderPickup" [form]="form" formKey="pickupContacts" (removeContactId)="removeContactId($event)"
                  [isAddContactEnabled$]="isAddPickupContactEnabled$" (onReachMaxContact)="onReachMaxContact($event)">
                  </contacts-form>
                </ng-template>
              </ng-container>

              <ng-container
                *ngIf="leftNavSelected == 'delivery'">
                <ng-container *ngIf="isAdding; else edit">
                  <contacts-form [entityId]="0" entityName="OrderDelivery" [form]="form" formKey="deliveryContacts" (removeContactId)="removeContactId($event)"
                  [isAddContactEnabled$]="isAddDeliveryContactEnabled$" (onReachMaxContact)="onReachMaxContact($event)">
                  </contacts-form>
                </ng-container>
                <ng-template #edit>
                  <contacts-form [entityId]="model?.id" entityName="OrderDelivery" [form]="form" formKey="deliveryContacts" (removeContactId)="removeContactId($event)"
                  [isAddContactEnabled$]="isAddDeliveryContactEnabled$" (onReachMaxContact)="onReachMaxContact($event)">
                  </contacts-form>
                </ng-template>
              </ng-container>

              <!-- errors -->
              <div *ngIf="errors.length > 0">
                <div *ngFor="let error of errors" class="small-text italic"
                  style="color:#b00; text-align: right; width: 100%; display: inline-block">
                  <ng-container *ngIf="(error.subkey == 'docs' && leftNavSelected == 'documents')">
                    <img alt="alert" src="./assets/images/alert.svg" /> {{error.message}}
                  </ng-container>
                  <ng-container
                    *ngIf="(error.subkey == 'contacts' && leftNavSelected == 'customer') || (error.subkey != 'contacts'
                  && (error.subkey != 'pickupContacts' && leftNavSelected == 'pickup') && (error.subkey != 'deliveryContacts' && leftNavSelected == 'deliveryDetails'))">
                    <img alt="alert" src="./assets/images/alert.svg"/> {{error.message}}
                  </ng-container>
                  <ng-container *ngIf="((error.subkey == 'pickupContacts' || error.subkey == 'pickupLocationExist') && leftNavSelected == 'pickup')">
                    <img alt="alert" src="./assets/images/alert.svg"/> {{error.message}}
                  </ng-container>
                  <ng-container *ngIf="((error.subkey == 'deliveryContacts' || error.subkey == 'deliveryLocationExist') && leftNavSelected == 'delivery')">
                    <img alt="alert" src="./assets/images/alert.svg"/> {{error.message}}
                  </ng-container>
                  <ng-container *ngIf="(error.subkey == 'customerOrLocationExist' && leftNavSelected == 'customer')">
                    <img alt="alert" src="./assets/images/alert.svg"/> {{error.message}}
                  </ng-container>
                </div>
              </div>

            </form>
            </div>
          </ng-container>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<!-- footer -->
<div class="ui-dialog ui-dialog-footer">
  <div class="modal-footer-custom">
    <div class="link-button d-inline-block">
      <a class="muted7" (click)="click('showCancel')">Cancel</a>
    </div>
    <div class="link-button float-right d-inline-block">
      <button *ngIf="navIndex > 0" class="link-button" type="submit" (click)="clickPrevious()">Previous</button>
      <button *ngIf="navIndex < (leftNav.length - 1)" class="link-button" type="submit"
        (click)="clickNext()">Next</button>
    </div>
  </div>
</div>

<!-- location search dialog -->
<p-dialog [(visible)]="showLocationSearch" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold">
      Search for a location
    </div>
    <p-autoComplete dataKey="id" [(ngModel)]="locationSearchString" field="label" inputStyleClass="simple-control"
      [style]="{ 'width': '100%' }" [suggestions]="locationItems" appendTo="body"
      (completeMethod)="locationSearch($event)" (onSelect)="locationSelect($event.value)"></p-autoComplete>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7"
          (click)="showLocationSearch = false; selectedLocation = null; locationSearchString = null">Cancel</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="selectLocation(leftNavSelected)">Select</button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- customer search dialog -->
<p-dialog [(visible)]="showCustomerSearch" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold">
      Search for a customer
    </div>
    <p-autoComplete dataKey="id" [(ngModel)]="locationSearchString" field="label" inputStyleClass="simple-control"
      [style]="{ 'width': '100%' }" [suggestions]="locationItems" appendTo="body"
      (completeMethod)="locationSearch($event)" (onSelect)="locationSelect($event.value)"></p-autoComplete>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7"
          (click)="showLocationSearch = false; selectedLocation = null; locationSearchString = null">Cancel</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="selectLocation(leftNavSelected)">Select</button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- cancel changes warning dialog-->
<p-dialog [(visible)]="showCancelWarning" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold">
      Are you sure you want to exit without saving? Any unsaved data will be lost.
    </div>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7" (click)="showCancelWarning = false;">No</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="click('cancel')">Yes</button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- cancel dialog -->
<p-dialog [(visible)]="showCancelDialog" [style]="{width: '40vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <ng-container *ngIf="cancelForm != null && showCancelDialog">
    <form [formGroup]="cancelForm">
      <div class="modal-body-custom">
        <table class="form-table">
          <thead>
            <tr>
              <th id="order-form-header" style="width: 35%"></th>
              <th id="order-form-cancelationReason"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{metadata['cancelationReason']}}</td>
              <td>
                <simple-control [label]="metadata['cancelationReason']" [form]="cancelForm" key="cancelationReason"
                  type="text"></simple-control>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ui-dialog ui-dialog-footer">
        <div class="modal-footer-custom">
          <div class="link-button d-inline-block">
            <a class="muted7" (click)="click('showCancelDialog')">Cancel</a>
          </div>
          <div class="link-button float-right d-inline-block">
            <button class="link-button" style="color: maroon !important" type="button" (click)="click('canceled')"
              [disabled]="!cancelForm.valid">Cancel Order</button>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</p-dialog>

<!-- revert dialog -->
<p-dialog [(visible)]="showRevetOrderDialog" [style]="{width: '40vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <ng-container *ngIf="revertForm != null && showRevetOrderDialog">
    <form [formGroup]="revertForm">
      <div class="modal-body-custom">
        <table class="form-table">
          <thead class="d-none">
            <tr>
              <th id="order-form-header" style="width: 35%"></th>
              <th id="order-form-cancelationReason"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="revert-cancel-box"> Revert Order Reason</td>
              <td>
                <simple-control [label]="'Revert Order Reason'" [form]="revertForm" key="revertOrderReason"
                  type="text"></simple-control>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ui-dialog ui-dialog-footer">
        <div class="modal-footer-custom">
          <div class="link-button d-inline-block">
            <a class="muted7" (click)="click('showRevetOrderDialog')">Cancel</a>
          </div>
          <div class="link-button float-right d-inline-block">
            <button class="link-button" style="color: maroon !important" type="button" (click)="click('reverted')"
              [disabled]="!revertForm.valid">Revert Order</button>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</p-dialog>

<!-- pickup cancel dialog -->
<p-dialog [(visible)]="showPickupCancelDialog" [style]="{width: '40vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <ng-container *ngIf="pickupCancelForm != null && showPickupCancelDialog">
    <form [formGroup]="pickupCancelForm">
      <div class="modal-body-custom">
        <table class="form-table">
          <caption class="d-none"></caption>
          <thead>
            <tr>
              <th id="order-form-pickup-cancel-dialog" style="width: 35%"></th>
              <th id="order-form-cancelationType"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td (click)="logPickupForm()">{{metadata['cancelationType']}}</td>
              <td>
                <simple-control [label]="metadata['cancelationType']" [form]="pickupCancelForm" key="cancelationType"
                  type="lookup" [items]="lookups.cancelationTypes"></simple-control>
              </td>
            </tr>
            <tr>
              <td>{{metadata['dryRun']}}</td>
              <td>
                <simple-control [label]="metadata['dryRun']" [form]="pickupCancelForm" key="dryRun" type="lookup"
                  [items]="lookups.yesNo"></simple-control>
              </td>
            </tr>
            <tr>
              <td>{{metadata['paymentToCustomer']}}</td>
              <td class="order-from-pd">
                <simple-control [label]="metadata['paymentToCustomer']" [form]="pickupCancelForm"
                  key="paymentToCustomer" type="lookup" [items]="lookups.yesNo" readonlyLabel="N/A"
                  [readonly]="isDryRun === false"></simple-control>
              </td>
            </tr>
            <tr>
              <td>{{metadata['paymentToCarrier']}}</td>
              <td class="order-from-pd">
                <simple-control [label]="metadata['paymentToCarrier']" [form]="pickupCancelForm" key="paymentToCarrier"
                  type="lookup" [items]="lookups.yesNo" readonlyLabel="N/A" [readonly]="isDryRun === false">
                </simple-control>
              </td>
            </tr>
            <tr *ngIf="isPaymentToCustomer && isDryRun">
              <td>{{metadata['customerDryRunFee']}}</td>
              <td class="order-from-pd">
                <simple-control [label]="metadata['customerDryRunFee']" [form]="pickupCancelForm"
                  key="customerDryRunFee" type="currency"></simple-control>
              </td>
            </tr>
            <tr *ngIf="isPaymentToCarrier && isDryRun">
              <td>{{metadata['carrierDryRunFee']}}</td>
              <td>
                <simple-control [label]="metadata['carrierDryRunFee']" [form]="pickupCancelForm" key="carrierDryRunFee"
                  type="currency"></simple-control>
              </td>
            </tr>
            <tr>
              <td>{{metadata['transportVehicle']}}</td>
              <td class="order-from-pd">
                <simple-control [readonly]="isCancellationInfoReadOnly" [label]="metadata['transportVehicle']" [form]="pickupCancelForm"
                  key="transportVehicle" type="lookup" [items]="lookups.yesNo"></simple-control>
              </td>
            </tr>
            <tr>
              <td>{{metadata['canceledBy']}}</td>
              <td class="order-from-pd">
                <simple-control [readonly]="isCancellationInfoReadOnly" [label]="metadata['canceledBy']" [form]="pickupCancelForm" key="canceledBy" type="text">
                </simple-control>
              </td>
            </tr>
            <tr>
              <td>{{metadata['cancelationReason']}}</td>
              <td class="order-from-pd">
                <simple-control [readonly]="isCancellationInfoReadOnly" [label]="metadata['cancelationReason']" [form]="pickupCancelForm"
                  key="cancelationReason" type="text"></simple-control>
              </td>
            </tr>
            <tr *ngIf="missingPaymentInfo && isDryRun">
              <td colspan="2">
                <div style="color: #b00; font-size: 0.85em; font-weight: normal">
                  * Customer or Carrier payment must be Yes
                </div>
              </td>
            </tr>
            <tr *ngIf="pickupCancelForm.get('transportVehicle').value == 2 && !isCancellationInfoReadOnly">
              <td colspan="4" class="upload-checkbox">
                <div class="upload-checkbox-label">Documents</div>
                <div>
                  <uploads [orderId]="model?.id" [orderGuid]="model?.guid" [isOrderDoc]="true" [isCheckBox]="true" (documentIds)="documentIds($event)" (rowsChange)="rowsChange($event)" [showAdd]="false" [showDelete]="false"></uploads>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ui-dialog ui-dialog-footer">
        <div class="modal-footer-custom">
          <div class="link-button d-inline-block">
            <a class="muted7" (click)="click('showPickupCancelDialog')">Cancel</a>
          </div>
          <div class="link-button float-right d-inline-block">
            <button class="link-button" style="color: maroon !important" type="button" (click)="click('cancelPickup')"
              [disabled]="!pickupCancelForm.valid || (missingPaymentInfo && isDryRun)"> {{ isCancellationInfoReadOnly ? 'Save': 'Cancel Order' }}</button>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</p-dialog>

<p-confirmDialog icon="pi pi-exclamation-triangle" [style]="{ 'width' : '25vw', 'min-width': '350px'}"
  styleClass="form-dialog" [acceptLabel]="'OK'" [rejectLabel]="'Cancel'" [acceptIcon]="null" [rejectIcon]="null">
</p-confirmDialog>

<ng-template #dateoverhaul let-data >
  <td class="date-overhaul-spacing carrier-text-alignment">
    <ng-container *ngIf="data.startDate; else dash">
     {{data.startDate}}
    </ng-container>
    <ng-template #dash>
     <span class="td-dynamic-data">
       —
     </span>
    </ng-template>
    <span *ngIf="data.dateType == 2"> -
      <ng-container *ngIf="data.endDate; else dash">
        {{data.endDate}}
      </ng-container>
      <ng-template #dash>
       <span class="td-dynamic-data">
         —
       </span>
      </ng-template>
    </span>
  </td>
</ng-template>

<!-- Confirm Delete Dialog for Addl Info, Pickup Phones, Delivery Phones -->
<confirm-delete-dialog
  [visible]="showDeleteWarning"
  [message]="deleteMessage"
  (confirm)="onDeleteConfirm($event)">
</confirm-delete-dialog>


